type Enviroment = 'local' | 'development' | 'staging' | 'production';
const env = (import.meta.env.VITE_REACT_APP_ENV as Enviroment) || 'local';
export const IS_LOCAL_ENV = import.meta.env.VITE_REACT_APP_ENV === 'local';

interface Features {
  accountStatus: boolean;
  paymentSchedule: boolean;
  convertion: boolean;
}

const FEATURE_FLAGS: Record<Enviroment, Features> = {
  local: {
    accountStatus: true,
    paymentSchedule: true,
    convertion: true,
  },
  development: {
    accountStatus: true,
    paymentSchedule: true,
    convertion: true,
  },
  staging: {
    accountStatus: true,
    paymentSchedule: true,
    convertion: true,
  },
  production: {
    accountStatus: true,
    paymentSchedule: true,
    convertion: true,
  },
};

const FEATURES_APP = FEATURE_FLAGS[env];

export default FEATURES_APP;
